import LightbulbOutlined from "@mui/icons-material/LightbulbOutlined";
import { Button } from "@mui/material";
import type { FC } from "react";

export const InsightsAvailableButton: FC<{ onClick: () => void }> = ({ onClick }) => (
  <Button
    variant="outlined"
    size="small"
    startIcon={<LightbulbOutlined />}
    onClick={onClick}
    data-analytics-id="insights-panel-open"
  >
    Insights available
  </Button>
);
